import { Checkbox } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "../TextField";
import { styled } from "@mui/system";
import { useFormikContext } from "formik";

const SelectTextField = styled(TextField)`
  width: ${(props) => (props.search ? `8rem` : "auto")};
  .MuiSelect-select {
    padding: 0.3rem 0.625rem;
  }
`;

const Select = ({
  name,
  label = "label",
  formikName,
  sx,
  items = [],
  multiple = false,
  isSimpleValue = false,
  ...props
}) => {
  const { values, setFieldValue } = useFormikContext();

  const findChecked = (value) => {
    return values?.[name]?.findIndex((item) => item?.id === value?.id) > -1;
  };
  return (
    <SelectTextField
      select
      autoWidth
      multiple
      renderInput
      inputProps={{ multiple, checkboxes: true }}
      formControl={{ sx }}
      formHelperText={{ children: "How old are you?" }}
      name={name}
      onChange={(e) => setFieldValue(name, e.target.value)}
      label={label}
      {...props}
    >
      {name !== "distributors" && (
        <MenuItem key="all" value={""}>
          All
        </MenuItem>
      )}
      {items?.map((item) => (
        <MenuItem key={item?.id} value={!isSimpleValue ? item?.value : item}>
          {multiple && <Checkbox checked={() => findChecked(item?.value)} />}
          {item?.label && item?.label}
          {item?.name && item?.name}
        </MenuItem>
      ))}
    </SelectTextField>
  );
};

export default Select;
